import React, { useState, useEffect } from 'react';
import TableAnt from './Table';
import { Radio } from 'antd';
import { getGroupedTableRows, getIndiaGroupedTableRows } from './Utils';

const TableHome = (props) => {

    const contentWidth = props.width-40;
    const contentHeight = props.height-300;

    let storedRadio = JSON.parse(localStorage.getItem('tableRadio'));
    const [mpMlaRadio, setMpMlaRadio] = useState(storedRadio ? storedRadio : 1);
    const [tableColumns, setTableColumns] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [stateIndex, setStateIndex] = useState(props.stateIndex);

    useEffect(() => {
        console.log('table Home use Effect called.');
        let { currentState, stateIndex, resultsMap, isMpMla } = props;
        let { mp, mla } = isMpMla;
        if(resultsMap&&resultsMap[currentState]) {
            let isIndia = stateIndex==0;
            let stateResultObj = mpMlaRadio==1 ? resultsMap[currentState].mla : resultsMap[currentState].mp;
            if(mp&&(!mla)) {
                stateResultObj = resultsMap[currentState].mp;
                setMpMlaRadio(2);
            }
            let { formattedColumns, formattedRows } = stateResultObj;
            setTableColumns(formattedColumns);
            console.log('formattedColumns=',formattedColumns);
            console.log('formattedRows=',formattedRows);
            let newFormatRows = [];
            if(isIndia) {
                newFormatRows = getIndiaGroupedTableRows(props, currentState, formattedRows, formattedColumns)
            } else {
                newFormatRows = getGroupedTableRows(currentState, formattedRows, formattedColumns, mpMlaRadio!=1);
            }
            setTableRows(newFormatRows);
            setStateIndex(stateIndex);
        }
    }, [props]);

    const onMPMLAChange = (e) => {
        let value = e.target.value;
        console.log('radio checked', value);
        let { currentState, resultsMap } = props;
        console.log('resultsMap[currentState]=',resultsMap[currentState]);
        let stateResultObj = value==1 ? resultsMap[currentState].mla : resultsMap[currentState].mp;
        let { formattedColumns, formattedRows } = stateResultObj;
        setMpMlaRadio(value);
        localStorage.setItem('tableRadio', JSON.stringify(value));
        setTableColumns(formattedColumns);
        let newFormatRows = getGroupedTableRows(currentState, formattedRows, formattedColumns, value!=1);
        setTableRows(newFormatRows);
    }

    console.log('stateIndex=',stateIndex,' tableColumns=',tableColumns,' tableRows=',tableRows);
    let isIndia = stateIndex==0;
    let { mp, mla } = props.isMpMla;

    return (
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <div style={{ flex: 1, padding: 20 }}>
                {
                    (mp&&mla)
                    ?
                    <Radio.Group onChange={onMPMLAChange} value={mpMlaRadio}>
                        <Radio key={'mla'} value={1}>MLA</Radio>
                        <Radio key={'mp'} value={2}>MP</Radio>
                    </Radio.Group>
                    :
                    (mp
                    ?
                    <Radio.Group value={2}>
                        <Radio key={'mp'} value={2}>MP</Radio>
                    </Radio.Group>
                    :
                    <Radio.Group value={1}>
                        <Radio key={'mla'} value={1}>MLA</Radio>
                    </Radio.Group>
                    )
                }
                    {
                        (tableColumns&&tableColumns.length>0)
                        ?
                        <div style={{ display: 'flex', maxWidth: contentWidth, paddingTop: 20 }}>
                            <TableAnt width={contentWidth} height={contentHeight} columns={tableColumns}
                            data={tableRows} isIndia={isIndia} />
                        </div>
                        :
                        <div />
                    }
            </div>
        </div>
    );
}

export default TableHome;